/**
 * Copy Trading API Switching Layer
 *
 * 환경변수 VITE_USE_MOCK_API에 따라 Mock API 또는 Real API를 선택
 *
 * ## 사용 방법
 *
 * ### Mock API 사용 (개발 중)
 * ```bash
 * # .env.development
 * VITE_USE_MOCK_API=true
 * ```
 *
 * ### Real API 사용 (프로덕션)
 * ```bash
 * # .env.production
 * VITE_USE_MOCK_API=false
 * ```
 *
 * ## 전환 방법
 *
 * 1. `src/app/api/copyTrading.real.ts` 파일 생성 (실제 API 클라이언트)
 * 2. `.env.production` 파일에서 `VITE_USE_MOCK_API=false` 설정
 * 3. 빌드 및 배포
 *
 * **완료!** Mock → Real API 전환 완료 (총 5분 소요)
 *
 * @see docs/COPY_TRADING_FRONTEND_PLAN.md#mock--real-api-전환
 */

/**
 * Real API만 사용 (Mock 완전 제거)
 */
console.log('[Copy Trading] Using Real API only');

// ==========================================
// Real API Direct Export (Mock 완전 제거)
// ==========================================

export * from './copyTrading.real';
